import { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./StudentDayAttendanceContent.css";

const StudentDayAttendanceContent = ({ attendanceData }) => {
  const attendanceSummary = attendanceData?.data || {};
  const attendanceList = attendanceSummary?.attendance_data || [];

  const cards = [
    { title: "Total Classes", value: attendanceSummary.sum_of_all ?? 0, isTotal: true },
    { title: "Absent", value: attendanceSummary.absent ?? 0, colorClass: "text-red" },
    { title: "Present", value: attendanceSummary.present ?? 0, colorClass: "text-green" },
    { title: "Partially Present", value: attendanceSummary.partial_present ?? 0, colorClass: "text-yellow" },
  ];

  return (
    <>
     

      <div className="attendance-cards">
        {cards.map((card, index) => (
          <div
            key={index}
            className={`attendance-card ${card.isTotal ? "total-card" : ""}`}
          >
            <p className="card-title">{card.title}</p>
            <p className={`card-value ${card.colorClass || ""}`}>
              {card.value}
            </p>
          </div>
        ))}
      </div>

      <h2 className="attendance-heading">Attendance details</h2>

      <div className="attendance-table">
        <div className="attendance-header">
          <span>Classes</span>
          <span>Time Spent / Total Class Time</span>
          <span>Polls Submitted / Total Polls</span>
          <span>Status</span>
        </div>

        {attendanceList.length > 0 ? (
          attendanceList.map((item, index) => (
            <div className="attendance-row" key={index}>
              <span>{item.class_no ?? "-"}</span>
              <span>
                {item.time_spent ?? "-"} / {item.total_spent ?? "-"}
              </span>
              <span>
                {item.max_poll_attempted ?? 0}/{item.zoom_api_poll_qns ?? 0}
              </span>
              <span>{item.present_status ?? "-"}</span>
            </div>
          ))
        ) : (
          <div className="no-data">No attendance data available</div>
        )}
      </div>
    </>
  );
};

export default StudentDayAttendanceContent;
